<template>
  <div class="flex justify-between p-2 bg-theme-700">
    <div class="flex items-center gap-2 text-white">
      <Icon icon="majesticons:close-line" class="w-6 h-6 cursor-pointer" @click="$emit('close')" />
      <div class="text-sm font-light">{{ selectedLength }} {{ $t('common.table.selected') }}</div>
    </div>
    <div class="flex items-center gap-10 text-sm font-light text-white">
      <button
        v-if="slots.extraButtonContent"
        class="flex gap-2 ml-10"
        @click="emit('emitSelectedItems')">
        <slot name="extraButtonContent" />
      </button>
      <button class="flex gap-2" @click="emit('move')" v-if="!hideMoveToButton">
        <span> {{ $t('common.actions.moveTo') }} </span>
        <Icon icon="@assortments:ic:folder-move" class="w-5 h-5 cursor-pointer" />
      </button>
      <button class="flex gap-2" @click="emit('defineSet')" v-if="!hideDefineSetButton">
        <span> {{ $t('common.actions.defineSet') }} </span>
        <Icon icon="@assortments:ic:folder" class="w-5 h-5 cursor-pointer" />
      </button>
      <button class="flex gap-2" @click="emit('exportToExcel')" v-if="!hideDownloadButton">
        <span> {{ $t('common.tooltip.download') }} </span>
        <Icon icon="ci:file-download" class="w-5 h-5" />
      </button>
      <button class="flex gap-2" @click="emit('deleteMultiselect')" v-if="!hideDeleteButton">
        <span> {{ $t('common.actions.delete') }} </span>
        <Icon icon="tdesign:delete-1" class="w-5 h-5 cursor-pointer" />
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Icon } from '@iconify/vue';
import { useSlots } from 'vue';
withDefaults(
  defineProps<{
    selectedLength: number;
    hideDownloadButton?: boolean;
    hideMoveToButton?: boolean;
    hideDefineSetButton?: boolean;
    hideDeleteButton?: boolean;
  }>(),
  {
    hideMoveToButton: true,
    hideDefineSetButton: true,
  }
);

const emit = defineEmits([
  'close',
  'exportToExcel',
  'deleteMultiselect',
  'move',
  'defineSet',
  'emitSelectedItems',
]);

const slots = useSlots();
</script>
